export default __webpack_public_path__ + "static/media/route.46bbdf0f.png";